import { formatINR } from "@/lib/api";
import { CalendarCheck, IndianRupee, Inbox, Users } from "lucide-react";

const StatCard = ({ icon: Icon, label, value, tint, testid }) => (
  <div className="bg-white rounded-2xl border border-slate-200 p-5 flex items-center gap-4 animate-fade-up" data-testid={testid}>
    <div className={`h-12 w-12 rounded-xl flex items-center justify-center ${tint}`}>
      <Icon className="h-6 w-6" />
    </div>
    <div>
      <div className="text-xs uppercase tracking-wider text-slate-400">{label}</div>
      <div className="font-head text-2xl font-bold text-slate-900">{value}</div>
    </div>
  </div>
);

export default function DashboardStats({ stats, pendingCount = 0, doctors }) {
  return (
    <>
      <div className="grid sm:grid-cols-2 xl:grid-cols-4 gap-4" data-testid="dashboard-stats">
        <StatCard icon={CalendarCheck} label="Total Appointments" value={stats.total_appointments ?? 0} tint="bg-teal-50 text-teal-600" testid="stat-total-appointments" />
        <StatCard icon={IndianRupee} label="Total Revenue" value={formatINR(stats.total_revenue ?? 0)} tint="bg-emerald-50 text-emerald-600" testid="stat-total-revenue" />
        <StatCard icon={Inbox} label="Pending Online Bookings" value={pendingCount} tint="bg-amber-50 text-amber-600" testid="stat-pending-online" />
        <StatCard icon={Users} label="Doctors" value={stats.total_doctors ?? 0} tint="bg-blue-50 text-blue-600" testid="stat-doctors" />
      </div>

      <div>
        <h2 className="font-head text-lg font-semibold mb-4">Doctor Roster</h2>
        <div className="grid sm:grid-cols-2 xl:grid-cols-4 gap-4">
          {doctors.map((d) => (
            <div key={d.id} className="bg-white rounded-2xl border border-slate-200 p-4 flex items-center gap-3">
              <img src={d.avatar} alt={d.name} className="h-14 w-14 rounded-full object-cover" />
              <div className="min-w-0">
                <div className="font-semibold text-slate-900 truncate">{d.name}</div>
                <div className="text-xs text-slate-500">{d.specialty}</div>
                <div className="text-sm font-mono text-teal-700 mt-1">{formatINR(d.fee)}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </>
  );
}
